import { createFileRoute, Outlet } from "@tanstack/react-router";
import { assetRouteLoader } from "../../features/staking/utils/route-loaders";

/**
 * Layout route for a specific staking asset.
 * Renders the asset index page via the .index child, and hosts stake/unstake/claim children.
 */
export const Route = createFileRoute("/_layout/staking/$asset")({
  loader: assetRouteLoader,
  component: AssetLayout,
});

function AssetLayout() {
  return <Outlet />;
}
